export const widgetStyles = {
  palette: {
    window: '#FFF',
    windowBorder: '#73af00',
    tabIcon: '#597a00',
    menuIcons: '#636363',
    textDark: '#262626',
    textLight: '#fafafa',
    link: '#73af00',
    action: '#0D8050',
    inactiveTabIcon: '#303030',
    error: '#D9822B',
    inProgress: '#73af00',
    complete: '#0D8050',
    sourceBg: '#dedede'
  },
  fonts: {
    'Karla': 'https://fonts.googleapis.com/css?family=Karla'
  }
}

export class ImageClass {
  constructor (name, publicId, width, height, cropConfig) {
    this.name = name
    this.publicId = publicId
    this.width = width
    this.height = height

    // TODO 이전엔 cropCofnig 를 percent 가 아니라 px 로 했었는데 그게 이상해지지않는지 확인해야함
    if (cropConfig) {
      if ((cropConfig.width < 1 || cropConfig.height < 1)) {
        this.cropConfig = cropConfig
      } else if (cropConfig.width > 1 || cropConfig.height > 1) {
        this.cropConfig = {
          width: cropConfig.width / 100,
          height: cropConfig.height / 100,
          x: cropConfig.x / 100,
          y: cropConfig.y / 100
        }
      }
    }
    this.isImage = true
  }
}
